/* import __COLOCATED_TEMPLATE__ from './customer-support.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();